import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';


export default class ResultsAjaxService extends Service 
{
	@service() config
	
	@computed('config')
	get host() 
	{
		return this.config.get('resultsBackendProtocol')+"://"+this.config.get('resultsBackendHost')+":"+this.config.get('resultsBackendPort');
	}
	
	@computed('config')
	get namespace() 
	{
		return this.config.get('resultsBackendNamespace');
	}
	
	request(url)
	{
		const namespaceWithSlash = this.namespace ? "/"+this.namespace : "";
		return fetch(this.host+namespaceWithSlash+url).then(function(response)
		{
			return response.json();
		});
	};
}
